var exports = {
  "iE": "x127c5a35--b7c9dc--wrapper",
  "oW": "x127c5a35--b7c9dc--folders",
  "Qs": "x127c5a35--b7c9dc--content",
  "kL": "x127c5a35--b7c9dc--container",
  "VX": "x127c5a35--b7c9dc--comment_to_folder",
  "RC": "x127c5a35--b7c9dc--preloader",
};

module.exports = exports;
